(function () {
    'use strict';

    function projectDrawScheduleItemsCollection($compile, $http, workflowProcessingService) {
        var templateUrl = 'workflow/directives/templates/projectDrawScheduleItemsCollection.html';

        return {
            restrict: 'E',
            scope: {
                InformationPart: '=informationPart',
                Datepickers: '=datepickers'
            },
            require: '^workflowPhase',
            link: function (scope, element, attrs, parentCtrl) {
                scope.adminMode = false;
                scope.$watch(function () {
                    return workflowProcessingService.adminMode;
                }, function (newValue) {
                    scope.adminMode = newValue;
                });

                //scope.datePickerIsOpened = false;
                //scope.openDatePicker = function ($event) {
                //    $event.preventDefault();
                //    $event.stopPropagation();

                //    scope.datePickerIsOpened = true;
                //};

                scope.$watch(function () {
                    return workflowProcessingService.adminMode;
                }, function (newValue) {
                    scope.adminMode = newValue;
                });

                scope.openDatepicker = function ($event, index) {
                    parentCtrl.openDatepicker($event, index);
                }

                scope.addItem = function () {
                    scope.InformationPart.ProjectDrawScheduleItems.push({});
                    parentCtrl.addDatepicker();
                };

                scope.removeItem = function (index) {
                    scope.InformationPart.ProjectDrawScheduleItems.splice(index, 1);
                    parentCtrl.removeDatepicker(index);
                };

                $http.get(templateUrl)
                      .then(function (response) {
                          element.html($compile(response.data)(scope));
                      });
            }
        };
    }

    projectDrawScheduleItemsCollection.$inject = ['$compile', '$http', 'workflowProcessingService'];

    angular.module('ecap.workflow').directive('projectDrawScheduleItemsCollection', projectDrawScheduleItemsCollection);
})();
